/* eslint-disable react/jsx-no-bind */
import React, {Component} from "react";
import Image from "./Image";
import PropTypes from "prop-types";
import TrendImages from "./TrendImages";

export default class StyleSurveyAnswers extends Component {
  static propTypes = {
    "answers": PropTypes.array.isRequired,
    "location": PropTypes.object.isRequired,
    "multiSelect": PropTypes.bool.isRequired,
    "nextRoute": PropTypes.string.isRequired,
    "onAnswer": PropTypes.func.isRequired,
    "surveyFields": PropTypes.object.isRequired,
    "updateField": PropTypes.func.isRequired
  };

  shouldDisplayTrendAnswers = () => {
    const {"location": {pathname}} = this.props;

    return pathname.substring(pathname.lastIndexOf("/"), pathname.length) === "/trends";
  };

  renderImages = () => {
    const {
      answers,
      location,
      multiSelect,
      nextRoute,
      onAnswer,
      surveyFields,
      updateField
    } = this.props;

    return (
      answers.map(answer =>
        <div
          className="response"
          key={answer.prompt}
          onClick={() => updateField(answer)}
        >
          <Image
            answer={answer}
            location={location}
            multiSelect={multiSelect}
            nextRoute={nextRoute}
            onAnswer={onAnswer}
            surveyFields={surveyFields}
          />
          <p className="lh24 mt8 mb32">
            {answer.prompt}
          </p>
        </div>)
    );
  };

  renderTrendImages = () => {
    const {
      answers,
      onAnswer,
      surveyFields
    } = this.props;

    return (
      <TrendImages
        answers={answers}
        onAnswer={onAnswer}
        surveyFields={surveyFields}
      />
    );
  };

  render () {
    return (
      <div className="StyleSurveyAnswers">
        {this.shouldDisplayTrendAnswers() ? this.renderTrendImages() : this.renderImages()}
      </div>
    );
  }
}
